const moment = require("moment");

module.exports = {
  getPaymentStatus(payment) {
    if (payment.status == "Paid") {
      if (moment(payment.payDate).isAfter(moment(payment.validity).endOf("day"))) return this.status.PaidOverdue;
      return this.status.Paid;
    }
    if (payment.status == "Canceled") return this.status.Canceled;
    const validity = moment(payment.validity).endOf("day");
    if (payment.status == "Pending" && moment().isAfter(validity)) return this.status.Expired;
    return this.status.Pending;
  },
  status: {
    Pending: {
      key: "pending",
      text: "A receber",
      color: "info"
    },
    Paid: {
      key: "paid",
      text: "Pago",
      color: "success"
    },
    PaidOverdue: {
      key: "paidOverdue",
      text: "Pago em atraso",
      color: "#3a7f06"
    },
    Canceled: {
      key: "canceled",
      text: "Cancelado",
      color: "error"
    },
    Expired: {
      key: "expired",
      text: "Vencido",
      color: "error"
    }
  },
  gateways: {
    Inter: {
      text: "Inter",
      color: "#f27321"
    },
    Omie: {
      text: "Omie",
      color: "blue"
    },
    Externo: {
      text: "Externo",
      color: "primary"
    }
  }
}
